
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Employee Sports Meet</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sport-meet section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Employee <span>Sports Meet</span></h2>
        </div>
        <div class="row g-5 flex-row-reverse">
            <div class="col-md-5">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sport-inv-23.jpg" alt="GHRSCF"
                    class="img-fluid">
            </div>
            <div class="col-md-7">
                <div class="widget_title inner-title">
                    <h4 class="fw-bold">Introduction of the Concept:</h4>
                </div>
                <p>Every year in the month of Jan. 3 day’s Annual sports and cultural event is organized for the
                    employees where all teaching and non-teaching staff participate in the sports. It is also one of
                    many such events organized by RGI</p>
                <div class="widget_title inner-title">
                    <h4 class="fw-bold">Existing Scenario:</h4>
                </div>
                <p> Every year the meet is organized where participation of employees takes place.</p>
                <div class="widget_title inner-title">
                    <h4 class="fw-bold">Reason behind Starting the Concept:</h4>
                </div>
                <p> Annual sports and Cultural meet is one of the opportunities that bring the RGI family together.</p>
                <div class="widget_title inner-title">
                    <h4 class="fw-bold">Vision or Goal of this Concept:</h4>
                </div>
                <p> It is an effort to build interpersonal relationships among employees, promote companionship,
                    commitment and teamwork.</p>
                <div class="widget_title inner-title">
                    <h4 class="fw-bold">Objectives of the concept:</h4>
                </div>
                <ul class="list-style list-style1">
                    <li> To provide rejuvenation to the employees o</li>
                    <li> Encouragement to their Sport and Cultural interests </li>
                    <li> To bridge the gap between various authorities.</li>
                </ul>
            </div>
        </div>
    </div>
</section>
<section class="section section-sm">
    <div class="container">
        <div class="widget_title inner-title">
            <h4 class="fw-bold">General Rules and Regulations to be followed strictly:</h4>
        </div>
        <ol class="list-count">
            <li> Spot Entry not allowed in any case</li>
            <li> Those who have registered through online form submission, they only can participate in the events :
                Forms will be closed on 16th January 2023</li>
            <li>
                Please find the Forms As under
                <ul class="list-style list-style1">
                    <li>
                        a. Badminton-
                        <a href="https://forms.gle/ci51WjgqfDfcbBVBA" target="_blank">
                            https://forms.gle/ci51WjgqfDfcbBVBA
                        </a>
                    </li>
                    <li>b. Chess- <a href="https://forms.gle/gexP6FnGrqe66Mnf9" target="_blank">
                            https://forms.gle/gexP6FnGrqe66Mnf9 </a></li>
                    <li>c. Carom-<a href="https://forms.gle/ETkhQ73q1g7NbDkS6" target="_blank">
                            https://forms.gle/ETkhQ73q1g7NbDkS6 </a></li>
                    <li>d. Pool Table-<a href="https://forms.gle/XuL2uaPySckTHhYC6" target="_blank">
                            https://forms.gle/XuL2uaPySckTHhYC6 </a></li>
                    <li>e. Table Tennis-<a href="https://forms.gle/BetzsUh6CGjv1A387" target="_blank">
                            https://forms.gle/BetzsUh6CGjv1A387 </a></li>
                    <li>f. Musical Chair-<a href="https://forms.gle/JVqChxRkesfKResy5" target="_blank">
                            https://forms.gle/JVqChxRkesfKResy5 </a></li>
                    <li>g. Solo Singing-<a href="https://forms.gle/xFjkc3A9RaB2jz6J7" target="_blank">
                            https://forms.gle/xFjkc3A9RaB2jz6J7 </a></li>
                    <li>h. Solo Dance-<a href="https://forms.gle/jWRUp29uQ38xNtkE6" target="_blank">
                            https://forms.gle/jWRUp29uQ38xNtkE6 </a></li>
                    <li>i. Writing-<a href="https://forms.gle/Tr1ja9GkwjaUjGeL8" target="_blank">
                            https://forms.gle/Tr1ja9GkwjaUjGeL8</a></li>
                </ul>
            </li>
            <li>Coordinator of the respective institutes will be responsible for the issues if any occurs from the
                participants</li>
            <li>Snack coupons will be given to the respective Institute’s coordination for the allotment On the
                respective day. (Extra coupons will not be issued)</li>
            <li>One coupon to one person will only be allowed for a day</li>
            <li>In cultural events, the expenses are to be borne by the participants. It is not a responsibility of
                organizers</li>
            <li>In Singing, only solo performances will be included, where in solo singing and solo dance, only 5
                finalists will get a chance to perform in the final cultural event</li>
            <li>Multiple participants from same institute will not be included</li>
            <li> The entries of the performances will be restricted to a limited number</li>
            <li> Institutes have to finalize either for group dance or for Fashion show</li>
            <li> Fashion Show – Details of the group and Theme finalized is to be sent on mail Id-<a
                    href="mailto:ghrscf.connect@raisoni.net">ghrscf.connect@raisoni.net</a> Maximum 7 mins strictly -
                Please do not request for any extension , participants can
                limit the number of people participating or manage the time (Last date of submission 10 <sup>th</sup>
                Jan 2023)</li>
            <li> The track is to be submitted by 16th Jan Strictly, to check the time and testing for final day</li>
            <li> Group Dance - Group details are to be sent on mail <a href="mailto:ghrscf.connect@raisoni.net">
                    ghrscf.connect@raisoni.net</a> Maximum 5 mins strictly (Last date of submission 10<sup>th</sup> Jan
                2023)</li>
            <li> Solo Singing (<a href="https://forms.gle/xFjkc3A9RaB2jz6J7"
                    target="_blank">https://forms.gle/xFjkc3A9RaB2jz6J7</a> ) and Solo Dance (
                <a href="https://forms.gle/jWRUp29uQ38xNtkE6" target="_blank">https://forms.gle/jWRUp29uQ38xNtkE6</a> )
                – 1 song 3 mins only– No Medley will be allowed Last date of submission 10<sup>th</sup> Jan 2023)
            </li>
            <li> Participants have to edit the song to limit them as per the time allotted</li>
            <li> Tug of wars – Maximum number in group should be 8</li>
            <li> For writing – only the original article will be entertained No poem is allowed the article must be
                limited to 5oo words strictly. Article should not include any offensive or abusive language. It should
                not be any religion or culture centric.
                Controversial topics are to be avoided. (Last date of submission 5<sup>th</sup> Jan 2023 ) <a
                    href="https://forms.gle/Tr1ja9GkwjaUjGeL8" target="_blank">https://forms.gle/Tr1ja9GkwjaUjGeL8</a>
            </li>
            <li> For group dance and fashion shows also the entries are restricted to 5 (Scrutiny will be there to
                select the finalist in case if Total entries are more than 5)</li>
            <li> Umpire or Judges Decision will be the last decision. No challenge will be entertained in any
                circumstances
            </li>
            <li> Ward Achievement award will be given to the kids who have achieved on district, state, National and
                International level in sports & cultural activity for the year 2021 - 2022.<a
                    href="https://forms.gle/GT6dczCmVWwir8Eh6" target="_blank"> https://forms.gle/GT6dczCmVWwir8Eh6</a>
            </li>
            <li> Kindly consider providing these details before 10<sup>th</sup> January 2023. Please fill up the forms
                <!-- Looking forward to make this annual event successful with all your support Website – https://ghrscf.com/ -->
        </ol>
    </div>
</section>
